import { gsap } from 'gsap'
import { SplitText } from 'gsap/SplitText'
import { DrawSVGPlugin } from 'gsap/DrawSVGPlugin'

gsap.registerPlugin(SplitText, DrawSVGPlugin)

const LINE_SVG = '<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 897 32" preserveAspectRatio="none" aria-hidden="true"><path stroke="currentColor" stroke-linecap="round" stroke-width="4" vector-effect="non-scaling-stroke" d="M2.001 32.307c1.54-.687 11.998-5.05 36.06-13.432C70.579 7.547 145.537 2.717 270.587 2.35c70.253-.207 154.183 8.59 199.659 13.01 50.109 4.87 61.663 9.427 80.242 9.206 27.149-.322 104.166-8.315 201.92-12.855C815.65.409 844.903 1.038 870.283 3.425c10.918.879 17.853 1.082 24.343 1.909"/></svg>'

const CIRCLE_SVG = '<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 946 195" preserveAspectRatio="none" aria-hidden="true"><path stroke="currentColor" stroke-linecap="round" stroke-width="4" vector-effect="non-scaling-stroke" d="M675.104 176.831c27.72-2.758 83.633-9.29 157.142-20.877 54.092-8.526 84.163-28.042 101.094-39.829 7.502-5.223 10.715-11.305 10.659-19.416s-4.007-18.682-13.857-28.73c-22.141-22.585-71.614-38.547-200.625-55.499C631.212-.437 463.543 1.185 341.947 3.837s-192.729 12.24-235.159 19.35C27.768 36.43 17.502 68.15 7.118 85.174c-4.69 7.692-6.471 23.726-4.015 31.603 4.712 15.111 4.178 40.061 71.089 54.887 47.437 10.512 124.31 17.863 203.668 20.568s159.4-1.817 247.144-12.056c87.745-10.239 180.769-26.058 276.611-42.906"/></svg>'

// Desktop scrubs with scroll; below `lg` plays once on enter.
const animate = (trigger, paths, to) => {
  const mm = gsap.matchMedia()

  mm.add('(min-width: 1024px)', () => {
    gsap.to(paths, {
      ...to,
      ease: 'none',
      scrollTrigger: {
        trigger,
        start: 'top 90%',
        end: 'top 30%',
        scrub: 0.5,
      },
    })
  })

  mm.add('(max-width: 1023.98px)', () => {
    gsap.to(paths, {
      ...to,
      duration: 1.8,
      ease: 'power2.out',
      stagger: 0.15,
      scrollTrigger: {
        trigger,
        start: 'top 85%',
        toggleActions: 'play none none reverse',
      },
    })
  })

  return mm
}

const decorateLine = (mark) => {
  let mm
  SplitText.create(mark, {
    type: 'lines',
    linesClass: 'mark-line-row',
    aria: 'none',
    autoSplit: true,
    onSplit(self) {
      mm?.kill()
      self.lines.forEach(line => line.insertAdjacentHTML('beforeend', LINE_SVG))
      const paths = self.lines.map(line => line.querySelector('path'))
      gsap.set(paths, { drawSVG: '0% 0%' })
      mm = animate(mark, paths, { drawSVG: '100%' })
    },
  })
}

const decorateCircle = (mark) => {
  mark.insertAdjacentHTML('beforeend', CIRCLE_SVG)
  const path = mark.querySelector(':scope > svg > path')
  const len = path.getTotalLength()
  gsap.set(path, { strokeDasharray: len, strokeDashoffset: len })
  animate(mark, path, { strokeDashoffset: 0 })
}

export default () => ({
  init() {
    this.$el.querySelectorAll('mark.line').forEach(decorateLine)
    this.$el.querySelectorAll('mark.circle').forEach(decorateCircle)
  },
})
